// Export the solutions data used in SolutionDetail/index.tsx
export const solutions = [
  {
    id: '1',
    title: 'AI-Powered Customer Service Platform',
    description: 'Intelligent platform that handles routine inquiries automatically and provides agents with AI assistance for complex issues',
    purpose: 'Improve customer satisfaction while reducing support costs',
    scaleMetrics: [
      { name: 'Volume', value: 8, color: '#4287f5' },
      { name: 'Velocity', value: 9, color: '#00CC99' },
      { name: 'Variety', value: 7, color: '#8A2BE2' },
      { name: 'Variability', value: 6, color: '#FFA500' },
      { name: 'Value', value: 9, color: '#FF4500' },
    ],
    successCriteria: [
      { id: '1', description: 'Reduce average response time by 50%' },
      { id: '2', description: 'Maintain customer satisfaction above 90%' },
      { id: '3', description: 'Automate handling of at least 60% of inquiries' },
    ],
    definitionOfDone: [
      { id: '1', description: 'System handles all common customer inquiries without human intervention' },
      { id: '2', description: 'Integration with existing CRM complete' },
      { id: '3', description: 'Agent dashboard provides real-time AI suggestions' },
    ],
    currentProcess: {
      title: 'Current Support Process',
      description: 'Manual ticket-based system with limited automation',
      steps: [
        { id: '1', description: 'Customer submits inquiry through web form or email' },
        { id: '2', description: 'Support agent manually reviews and categorizes ticket' },
        { id: '3', description: 'Agent researches solution in knowledge base' },
        { id: '4', description: 'Agent responds to customer with solution' },
        { id: '5', description: 'Ticket remains open until customer confirms resolution' },
      ],
    },
    futureProcess: {
      title: 'AI-Powered Support Process',
      description: 'Automated system with AI assistance for complex issues',
      steps: [
        { id: '1', description: 'Customer submits inquiry through any channel (web, email, chat)' },
        { id: '2', description: 'AI automatically categorizes and prioritizes inquiry' },
        { id: '3', description: 'Common inquiries are answered immediately by AI' },
        { id: '4', description: 'Complex issues are routed to agents with AI-suggested solutions' },
        { id: '5', description: 'System follows up automatically to confirm resolution' },
      ],
    },
    financials: {
      current: [
        { id: '1', name: 'Support staff costs', amount: 450000, type: 'risk' },
        { id: '2', name: 'Training expenses', amount: 75000, type: 'risk' },
        { id: '3', name: 'Customer churn due to slow response', amount: 120000, type: 'risk' },
        { id: '4', name: 'Current support revenue', amount: 350000, type: 'profit' },
      ],
      future: [
        { id: '1', name: 'Platform implementation', amount: 180000, type: 'risk' },
        { id: '2', name: 'Ongoing maintenance', amount: 45000, type: 'risk' },
        { id: '3', name: 'Reduced support staff costs', amount: 250000, type: 'profit' },
        { id: '4', name: 'Improved customer retention', amount: 180000, type: 'profit' },
        { id: '5', name: 'New customer acquisition', amount: 220000, type: 'profit' },
      ],
    },
    useCases: {
      current: [
        {
          id: '1',
          title: 'Manual Ticket Processing',
          description: 'Support agents manually process each ticket, taking 2-3 hours on average to resolve customer inquiries.',
        },
        {
          id: '2',
          title: 'Knowledge Base Lookup',
          description: 'Agents search through knowledge base articles to find solutions, often with inconsistent results.',
        },
      ],
      future: [
        {
          id: '1',
          title: 'Automated Response System',
          description: 'AI automatically responds to common inquiries within seconds, with 90% accuracy.',
        },
        {
          id: '2',
          title: 'Agent Assistance Dashboard',
          description: 'Support agents receive AI-generated suggestions for complex issues, reducing resolution time by 40%.',
        },
        {
          id: '3',
          title: 'Proactive Customer Outreach',
          description: 'System identifies potential issues before customers report them and initiates proactive support.',
        },
      ],
    },
  },
  {
    id: '2',
    // Copy the other solution data here
  }
]; 